import { MultiSelectInputView } from '@optiro/ui';

import { useAccounts } from '@/hooks/useAccounts';
import { Account } from '@/types/types';

export const SelectManager = ({
  value,
  label,
  onChange,
}: {
  value: Account['id'][];
  label?: string;
  onChange: (value: Account['id'][]) => void;
}) => {
  const { data: accounts } = useAccounts();

  const options =
    accounts?.map((account) => ({ value: String(account.id), label: account.name })) || [];

  return (
    <MultiSelectInputView
      data={options}
      label={label}
      placeholder="Vælg ledere"
      required
      value={value.map(String)}
      onChange={onChange}
      size="md"
    />
  );
};

export default SelectManager;
